var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftShort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 8,
    viewBox: "0 0 10 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 4C9.5 4.31066 9.24816 4.5625 8.9375 4.5625H2.4205L4.83525 6.97725C5.05492 7.19692 5.05492 7.55308 4.83525 7.77275C4.61558 7.99242 4.25942 7.99242 4.03975 7.77275L0.664752 4.39775C0.445083 4.17808 0.445083 3.82192 0.664752 3.60225L4.03975 0.227252C4.25942 0.00758251 4.61558 0.00758251 4.83525 0.227252C5.05492 0.446922 5.05492 0.803079 4.83525 1.02275L2.4205 3.4375L8.9375 3.4375C9.24816 3.4375 9.5 3.68934 9.5 4Z",
    fill: "#023047"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftShort);
export default __webpack_public_path__ + "static/media/arrow-left-short.c771a6058291095668d214748853f297.svg";
export { ForwardRef as ReactComponent };